import SharedAsset from '@zenbusiness/common-components/SharedAsset';
import Text from '@zenbusiness/common-components/Text';
import PropTypes from 'prop-types';

import Grid from '@mui/material/Grid';

const CreatedWithZBLogo = ({ className }) => (
  <Grid
    container
    direction="column"
    justifyContent="flex-end"
    alignItems="flex-end"
    className={className}
  >
    <SharedAsset
      src="/logo/zb-logo-2022-black.svg"
      alt="zest-exercise"
      width={44}
    />
    <Text size="sm" bold>created with</Text>
  </Grid>
);

CreatedWithZBLogo.propTypes = {
  className: PropTypes.string
};

CreatedWithZBLogo.defaultProps = {
  className: null
};

export default CreatedWithZBLogo;
